function handleLazyLoadPictures() {
    // Select all elements with the `lazy-load` class
    const lazyElements = document.querySelectorAll('.lazy-load-picture');
  
    lazyElements.forEach((lazyElement) => {
      // Find the picture tag inside the anchor element
      const picture = lazyElement.querySelector('picture');
      if (picture) {
        // Handle the <source> tags
        const sources = picture.querySelectorAll('source');
        sources.forEach((source) => {
          const dataSrcset = source.getAttribute('data-srcset');
          if (dataSrcset) {
            source.setAttribute('srcset', dataSrcset);
            source.removeAttribute('data-srcset');
          }
        });
  
        // Handle the <img> tag
        const img = picture.querySelector('img');
        if (img) {
          const dataSrc = img.getAttribute('data-src');
          if (dataSrc) {
            img.setAttribute('src', dataSrc);
            img.removeAttribute('data-src');
          }
        }
      }
    });
  }
  ['click', 'mousemove', 'touchstart', 'scroll'].forEach((event) => {
    window.addEventListener(event, () => {
      handleLazyLoadPictures();
    }, { once: true });
  });